import { Box, Button, Heading, Image, Stack, Text, useMediaQuery } from '@chakra-ui/react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import SessionStartLogo from '../../components/SessionStartLogo'
const quilmesImages = require.context('../../assets/images', true)

const RegisterSuccess = () => {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const [mail, setMail] = useState(() => {
    const email = sessionStorage.getItem('mail')

    return JSON.parse(email)
  })

  const handleClick = () => {
    sessionStorage.removeItem('mail')
  }

  return (
    <Box
      display={{ md: 'flex' }}
      justifyContent={'center'}
    >
      <Box mx={'auto'}>
        <Box
          alignItems={'flex-start'}
          autoComplete='off'
          padding={{ base: '2rem 1rem 2rem 1rem', md: '4rem 1rem 2rem 1rem' }}
          w={{ base: '100%', md: 500 }}
        >
          <SessionStartLogo />
          <Box
            paddingTop={{ base: '2rem', md: '4rem' }}
          >
            <Heading
              fontSize={'24px'}
              fontWeight={'400'}
            >
              ¡Listo! Tu cuenta fue creada.
            </Heading>
            <Text fontSize={'14px'} paddingTop={4}>
              Te hemos enviado un correo electrónico a  <b>{mail}</b>
            </Text>
            <Text fontSize={'14px'}>
              Recordá que tenés que verificar tu correo  para poder ingresar a tu cuenta.
            </Text>
          </Box>
          <Stack justifyContent='center' paddingTop={12} w={{ base: '100%', md: 400 }}>
            <Link to="/" onClick={handleClick}>
              <Button
                _focusVisible={{ outline: 'none' }}
                type='submit'
                variant={'btn-quilmes'}
              >
                Iniciar Sesión
              </Button>
            </Link>
          </Stack>
        </Box>
      </Box>
      <Box
        alignItems={'center'}
        bgColor={'#F7F7F7'}
        justifyContent={'center'}
        w={'50%'}
        {...(isLargerThan768
          ? { margin: '0', height: '100vh' }
          : { margin: '0 auto', height: 'auto' })}
      >
        {isLargerThan768
          ? (
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'2.5rem'}
              src={quilmesImages('./ilustracion.svg')}
              w={{ md: '50%' }}
            />
          )
          : null}
      </Box>
    </Box>
  )
}

export default RegisterSuccess
